import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  body14BoldStyles,
  body14Styles,
  h3Styles,
  h4Styles,
} from "@constants/typography"
import styled, { css } from "styled-components"

export enum TabTypes {
  Details = 0,
  Installation = 2,
  Resources = 3,
  Reviews = 1,
}

export const DEFAULT_FENIX_METHODS = Object.freeze([
  "FedEx 2Day",
  "FedEx Next Day",
  "USPS Shipping",
  "USPS Free Shipping",
])

export const Content = styled.div``

export const TabsBlock = styled.div`
  padding: 60px 0 72px;
  border-bottom: 1px solid ${colors.dividerLineGray};

  @media ${breakpoints.tablet} {
    padding: 80px 0 42px;
  }

  @media ${breakpoints.laptop} {
    flex-direction: column;
    display: flex;
    padding: 148px calc(1 / 12 * 100vw) 170px;
    border-bottom: none;
  }
`

export const Tabs = styled.div`
  display: flex;
  padding: 0 20px;

  @media ${breakpoints.laptop} {
    padding: 0;
  }
`

export const Tab = styled.button<{ $active: boolean }>`
  ${({ $active }) => css`
    ${h4Styles}
    margin-right: 6px;
    padding: 0;
    outline: none;
    border: none;
    background: none;
    font-size: 14px;
    color: ${$active ? colors.black : colors.mediumGray};

    &:hover {
      cursor: pointer;
    }

    &:focus,
    &:active {
      outline: none;
    }

    @media ${breakpoints.laptop} {
      ${h3Styles}
      margin-right: 60px;
      padding: 0;
      font-size: 32px;
      line-height: 66px;
      border-bottom: ${$active ? `solid 3px ${colors.black}` : "none"};
    }
  `}
`

export const TabContent = styled.div<{ $active: boolean }>`
  ${({ $active }) => css`
    display: ${$active ? "block" : "none"};
  `}
`

export const Text = styled.span`
  ${body14Styles}
  color: ${colors.offBlack};
`

export const TextBold = styled.span`
  ${body14BoldStyles}
  color: ${colors.black};
`

export const Spacer = styled.span`
  display: inline-block;
  width: 3px;
`
